import type { SxProps, Theme } from '@mui/material/styles'

export const VIEWER_UPPER_TOOLBAR_GAP = 1

/** Padding horizontal / vertical du bandeau ViewerUpper (Toolbar). */
export const VIEWER_UPPER_TOOLBAR_PADDING_X = '8px'
export const viewerUpperToolbarPaddingSx = {
  pt: 1,
  pb: 1,
  px: VIEWER_UPPER_TOOLBAR_PADDING_X,
} as const

export const viewerUpperToolbarRowSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'nowrap',
  width: '100%',
  minWidth: 0,
  overflow: 'visible',
} as const

/** Hauteur alignée sur les Select `size="small"` du ViewerUpper (25px). */
export const VIEWER_UPPER_CONTROL_HEIGHT = 25

export const viewerUpperOutlinedControlSx = (theme: Theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius}px`,
  backgroundColor: theme.palette.background.paper,
  boxSizing: 'border-box' as const,
})

export const viewerUpperIconButtonSx = (theme: Theme) => ({
  ...viewerUpperOutlinedControlSx(theme),
  width: VIEWER_UPPER_CONTROL_HEIGHT,
  height: VIEWER_UPPER_CONTROL_HEIGHT,
  minWidth: VIEWER_UPPER_CONTROL_HEIGHT,
  minHeight: VIEWER_UPPER_CONTROL_HEIGHT,
  p: 0,
  flexShrink: 0,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.neutral?.[300] ?? theme.palette.divider,
  },
  '&.Mui-disabled': {
    opacity: 0.45,
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
  },
})

export const viewerUpperToolbarTextButtonSx: SxProps<Theme> = (theme) => ({
  ...viewerUpperOutlinedControlSx(theme),
  height: VIEWER_UPPER_CONTROL_HEIGHT,
  minHeight: VIEWER_UPPER_CONTROL_HEIGHT,
  minWidth: 'unset',
  py: 0,
  px: 1,
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: 1,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.neutral?.[300] ?? theme.palette.divider,
  },
  '&.Mui-disabled': {
    opacity: 0.45,
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
  },
})

export const viewerUpperSelectSx = {
  height: `${VIEWER_UPPER_CONTROL_HEIGHT}px !important`,
  borderWidth: 0,
  '& .MuiSelect-select': {
    py: 0,
    display: 'flex',
    alignItems: 'center',
  },
} as const
